export function formatCardNumber(text: string, card: Card) {
  const numbers = text.replace(/\D/g, '');
  let formated = '';
  let indexes = card.format.reduce((prev, curr, idx) => [...prev, [prev[idx][1], prev[idx][1] + curr]], [[0,0]]);
  indexes = indexes.slice(1);
  formated = indexes.reduce((prev, [start, end]) => `${prev} ${numbers.slice(start, end)}`, '');
  formated = formated.trim();
  return formated;
}

export function formatExpirationDate(text: string) {
  const numbers = text.replace(/\D/g, '');
  let formated = numbers;
  if (numbers.length > 2) {
    formated = `${numbers.slice(0,2)}/${numbers.slice(2,4)}`;
  }
  return formated;
}

export function formatCVC(text: string, card: Card) {
  const numbers = text.replace(/\D/g, '');
  let maxLen = card.cvcLength;
  let formated = numbers.slice(0, maxLen);
  return formated;
}

export function getCardType(text: string) {
  const numbers = text.replace(/\D/g, '');
  let cardFound: Card, matchFound: string;
  for (const card of cards) {
    const match = numbers.match(card.pattern);
    if (match) {
      if (!cardFound || match[0].length > matchFound.length) {
        cardFound = card;
        matchFound = match[0];
      }
    }
  }
  return cardFound || cards[0];
}

type Card = {
  type: 'visa' | 'amex' | 'mastercard' | 'discover';
  pattern: RegExp;
  format: number[];
  numLength: number;
  cvcLength: number;
}

const cards: Card[] = [
  {
    type: 'visa',
    pattern: /^4/,
    format: [4, 4, 4, 4],
    numLength: 16,
    cvcLength: 3,
  },
  {
    type: 'amex',
    pattern: /^3[47]/,
    format: [4, 6, 5],
    numLength: 15,
    cvcLength: 4,
  },
  {
    type: 'mastercard',
    pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
    format: [4, 4, 4, 4],
    numLength: 16,
    cvcLength: 3,
  },
  {
    type: 'discover',
    pattern: /^(6011|65|64[4-9]|622)/,
    format: [4, 4, 4, 4],
    numLength: 16,
    cvcLength: 3,
  }
];
